module.exports = __webpack_public_path__ + "img/ntaa.c3786098.png";